/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleModel } from '../../models/article-model';

export interface ArticlePublisherIdPost$Plain$Params {
  publisherId: string;
      body?: ArticleModel
}

export function articlePublisherIdPost$Plain(http: HttpClient, rootUrl: string, params: ArticlePublisherIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdPost$Plain.PATH, 'post');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<string>;
    })
  );
}

articlePublisherIdPost$Plain.PATH = '/Article/{publisherId}';
